export const authFetch = async (url, options = {}) => {
    const token = localStorage.getItem('accessToken');

    const headers = {
        'Content-Type': 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
        ...options.headers,
    };

    const response = await fetch(url, {
        ...options,
        headers,
    });

    // Optional: handle token expiry globally
    if (response.status === 401) {
        // logout or refresh token logic here
        localStorage.clear();
        window.location.href = '/login';
        return;
    }

    return response;
};
